import ExceptionalCircumstances from './ExceptionalCircumstances';
import { TravelInsurance } from './TravelInsurance';

export default function NoRefundChangeDates() {
  return (
    <div>
      <h6>Unfortunately it's no longer possible to change dates</h6>

      <p>
        As you are less than 2 months before the start of the trip, it's
        unfortunately no longer possible to change dates. Please keep reading
        for details and alternative options.
      </p>

      <p>
        We do appreciate this may not the outcome you were hoping for.
        Unfortunately, by this point all bookings are treated as final, so that
        the local guides who run your trip can make all the arrangements. This
        typically includes booking accommodation, arranging transport, and
        making other preparations for your arrival.
      </p>

      <p>
        As the guides will have incurred all these expenses already, they are no
        longer able to offer a date change. This is because that would otherwise
        result in them incurring the same expenses twice for your booking – for
        the original trip as well as for the new date.
      </p>

      <ExceptionalCircumstances />

      <TravelInsurance />
    </div>
  );
}
